<template>
  <!-- 客服聊天界面 -->
  <div class="service" @click="hiddenMenu" ref="service">
    <!-- 复制容器 -->
    <input type="text" id="copyContainer" style="opacity: 0;position: absolute;top: 0">
    <div id="menu" class="menu" v-if="showMenu">
      <div class="menu-item" v-if="currentMessage.showCopy" @click.prevent="toCopy">{{ $lang.copy }}</div>
      <div class="menu-item" @click.prevent="handleMessageRecall" v-if="currentMessage.showRecall">{{ $lang.withdraw }}</div>
    </div>
    <!-- 头部 -->
    <Header :title="customerNickName ? customerNickName : title" :showBack="!($route.query.platformType === '0' && $route.query.platformUserType === '2')" @back="goBack">
      <template #rightArea>
        <img src="../assets/img/history.png" alt="" :title="$lang.history" @click="showHistory = true" v-if="serviceId">
      </template>
    </Header>
    <SafeTips/>
    <!-- 聊天内容区域 -->
    <MessageList :list="chatData" @longPress="handleItemLongPress" id="chatContent">
      <div slot="message-head">
        <!-- 暂无在线客服 -->
        <div class="system-message" v-if="noService">{{noServiceTxt}}</div>
        <!-- 前面有人排队 -->
        <div class="line-count" v-if="waitUserCount > -1">-- 前面有 {{waitUserCount + 1}} 人在排队 --</div>
      </div>
    </MessageList>
    <!-- 编辑区域 -->
    <div class="edit" v-if="serviceId">
      <div class="top">
        <!-- 表情图标 -->
        <div class="emoji-img" @click.stop="showEmojiPicker = !showEmojiPicker">
          <img src="../assets/img/emoji.png" alt="">
        </div>
        <!-- 输入框 -->
        <el-input id="input" @keydown.prevent.enter.native="sendText" @paste.native="textPaste($event)" v-model="input" maxlength="500" :placeholder="$lang.inputPlaceholder" type="textarea" autosize resize="none" ref="input"></el-input>
        <!-- 发送按钮 -->
        <div class="send-btn" @click="sendText" v-if="showSendBtn">{{ $lang.send }}</div>
        <!-- 加号图标 -->
        <div class="add-img" @click.stop="showFile = !showFile" v-if="!showSendBtn">
          <img src="../assets/img/add.png" alt="">
        </div>
      </div>
      <!-- 表情选择器 -->
      <Emoji @select="selectEmoji" class="emoji-picker" :show.sync="showEmojiPicker" @change-category="handleChangeCategory" />
      <div class="bottom" v-show="showFile">
        <!-- 图片 -->
        <div class="menu-item">
          <div class="img-icon" @click="openImgUpload">
            <img src="../assets/img/img.png" alt="">
          </div>
          <div class="menu-title">{{ $lang.photoAlbum }}</div>
        </div>
        <input type="file" accept="image/*" v-show="false" ref="imgUpload" @change="handleImgChange" @click.stop=""/>
        <div class="menu-item">
          <div class="img-icon" @click="openVideoUpload">
            <img src="../assets/img/video.png" alt="">
          </div>
          <div class="menu-title">{{ $lang.video }}</div>
        </div>
        <input type="file" accept="video/*" v-show="false" ref="videoUpload" @change="handleVideoChange" @click.stop=""/>
        <!-- 文件 -->
        <div class="menu-item">
          <div class="file-icon" @click="openFileUpload">
            <img src="../assets/img/file.png" alt="">
          </div>
          <div class="menu-title">{{ $lang.file }}</div>
        </div>
        <!-- pc和ios -->
        <input v-if="!isPhone || isIos" type="file" accept=".doc,.docx,.pdf, .ppt, .pptx" v-show="false" ref="fileUpload" @change="handleFileChange" @click.stop=""/>
        <!-- 安卓 -->
        <input v-else type="file" v-show="false" ref="fileUpload" @change="handleFileChange" @click.stop=""/>
      </div>
    </div>
    <!-- 评价弹框 -->
    <van-overlay :show="showEvaluate" class="overlay">
      <div class="wrapper" @click.stop>
        <img src="../assets/img/close_rules.png" alt="" class="evaluate-close" @click="logout">
        <div class="evaluate-title">{{ $lang.serviceRating }}</div>
        <div class="tips" v-html="$lang.rantingLead.replace('%template%', customerNickName)"></div>
        <div class="evaluate-result">
          <div class="result-box">
            <!-- 满意没选中 -->
            <img @click="changeResult(1)" src="../assets/img/evaluation_icon5.png" alt="" v-if="evaluationForm.satisfaction !== 1">
            <!-- 满意选中 -->
            <img src="../assets/img/evaluation_icon6.png" alt="" v-if="evaluationForm.satisfaction === 1">
            <span>{{ $lang.satisfactory }}</span>
          </div>
          <div class="result-box">
            <!-- 不满意没选中 -->
            <img @click="changeResult(2)" src="../assets/img/evaluation_icon1.png" alt="" v-if="evaluationForm.satisfaction !== 2">
            <!-- 不满意选中 -->
            <img src="../assets/img/evaluation_icon2.png" alt="" v-if="evaluationForm.satisfaction === 2">
            <span>{{ $lang.unsatisfactory }}</span>
          </div>
        </div>
        <div class="tabs-title">
          <div class="title-tip">{{ evaluationForm.satisfaction === 1 ? $lang.satisfactoryOptionsTips : $lang.unSatisfactoryOptionsTips }}</div>
        </div>
        <!-- 评价标签列表 -->
        <div class="tabs">
          <div class="tabs-item" @click="changeTabs(item.value)" v-for="(item, index) in rantingLabelList" :key="index" v-if="item.satisfaction === evaluationForm.satisfaction" :class="{isSelected:evaluationForm.evaluationLabel.includes(item.value)}">{{item.title}}</div>
        </div>
        <el-input
          :rows="4"
          type="textarea"
          v-model="evaluationForm.evaluationContent"
          maxlength="200"
          show-word-limit
          resize="none"
          class="evaluate-input"
        />
        <el-button type="primary" size="mini" class="evaluate-submit" @click="submitEvaluate" v-loading="isEvaluateLoading">{{ $lang.submit }}</el-button>
        <div class="no-submit" @click="noSubmit">{{ $lang.noSubmit }}</div>
      </div>
    </van-overlay>
    <!-- 历史记录 -->
    <History v-if="showHistory" @close="showHistory = false" />
    <!-- 无客服在线时 显示留言弹框 -->
    <div class="leave-message-container" v-if="showMessage">
      <div class="message">
        <p class="close" @click="logout">x</p>
        <p class="tips">{{ $lang.problemFeedback }}</p>
        <div class="item">
          <p class="label">{{ $lang.account }}</p>
          <span class="input-area">
            <el-input v-model="messageForm.platformAccount" :placeholder="$lang.accountPlaceholder"></el-input>
          </span>
        </div>
        <div class="item">
          <p class="label">{{ $lang.registeredPhone }}</p>
          <span class="input-area">
            <el-input v-model="messageForm.phone" :placeholder="$lang.phonePlaceholder"></el-input>
          </span>
        </div>
        <div class="item alignTop">
          <p class="label">{{ $lang.problemDescription }}</p>
          <span class="input-area">
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6}" :placeholder="$lang.problemDescriptionPlaceholder" resize="none" :maxlength="2000" v-model="messageForm.noteInfo"></el-input>
          </span>
        </div>
        <div class="submit-btn" @click="submitMessage" v-loading="isMessageSubmitLoading">{{ $lang.submit }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import createWebSocket from '../utils/websocket.js'
import History from '../components/History.vue'
import Emoji from '../components/Emoji.vue'
// 接收以下消息不展示
import noShowMessage from '../config/noShowMessage.json'
// 接收以下消息退出登录
import logoutMessage from '../config/logoutMessage.json'
import {queryIsUserEndSession, imgOrTextCheck, queryImNoteSet, imgUpload, submitImNoteRecord, queryChatHistoryRecord, submitImEvaluationRecord, addImUser, movConversionMp4, messageRecall} from '../api/index'
import SafeTips from '../components/SafeTips.vue'
import MessageList from '../components/MessageList'
import $ from 'jquery'
import TIM from 'tim-js-sdk'
import { Dialog, Toast } from 'vant'
import baseURL from '../config/index'
import formatDateByTimestamp from '../utils/formatDateByTimestamp.js'
export default {
  components: {
    SafeTips,
    History,
    MessageList,
    Emoji
  },
  async created () {
    this.handleUserLogin()
    this.initAppInteractive()
  },
  mounted () {
    // 用户id不存在时，生成随机id 并修改路由
    if (!this.$route.query.platformUserId) {
      this.updateUrlRandomUserId()
    }
  },
  beforeDestroy () {
    this.unbindGetPageIsHiddenEvent()
    this.myWebsocket && this.myWebsocket.close()
    this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    platformInfo () {
      return this.$store.state.platformInfo
    }
  },
  data () {
    return {
      // websocket对象
      myWebsocket: null,
      isOverTime: false,
      // 自动结束会话定时器
      autoEndChatTimer: null,
      platformUserId: this.$route.query.platformUserId || '',
      isEvaluateLoading: false,
      isMessageSubmitLoading: false,
      isSendCustom: false,
      queryForm: this.$route.query,
      // satisfaction 1 为满意标签 2为不满意标签
      rantingLabelList: [
        {
          title: this.$lang.goodAttitude,
          value: 1,
          satisfaction: 1
        },
        {
          title: this.$lang.respondPromptly,
          value: 2,
          satisfaction: 1
        },
        {
          title: this.$lang.solveTheProblem,
          value: 3,
          satisfaction: 1
        },
        {
          title: this.$lang.badAttitude,
          value: 4,
          satisfaction: 2
        },
        {
          title: this.$lang.noRespondInTime,
          value: 5,
          satisfaction: 2
        },
        {
          title: this.$lang.notSolvingTheProblem,
          value: 6,
          satisfaction: 2
        }
      ],
      // 是否需要相册权限判断
      authority: Number(this.$route.query.authority),
      copyImgFile: '',
      showMessage: false,
      messageForm: {
        platformType: this.$route.query.platformType ? Number(this.$route.query.platformType) : '',
        platformAccount: this.$route.query.platformUserId,
        phone: (['undefined', 'null', ''].includes(this.$route.query.platformPhone) ? '' : this.$route.query.platformPhone),
        noteInfo: ''
      },
      // 是否显示右键菜单
      showMenu: false,
      // 当前准备撤回的消息
      currentMessage: '',
      isPhone: Boolean(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)),
      // 是否是ios设备
      isIos: Boolean(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)),
      platformType: Number(this.$route.query.platformType),
      platformUserType: Number(this.$route.query.platformUserType),
      title: this.$lang.linkService,
      // 是否显示无客服文案
      noService: false,
      // 无客服时 文案
      noServiceTxt: '',
      // 评价弹框
      showEvaluate: false,
      // 聊天记录
      chatData: [],
      // 连接的客服id
      serviceId: '',
      // 连接的客服昵称
      customerNickName: '',
      // 评价
      evaluationForm: {
        byEvaluationId: '',
        evaluationContent: '',
        evaluationId: '',
        evaluationLabel: [],
        evaluationType: 1,
        satisfaction: 1
      },
      showEmojiPicker: false,
      showFile: false,
      showSendBtn: false,
      imUserInfo: '',
      input: '',
      // socket: '',
      socketUrl: baseURL.socketUrl,
      showHistory: false,
      // 是否下拉加载状态
      isLoading: false,
      chatRecord: [],
      // 排队人数
      waitUserCount: -1,
      // 系统自动结束会话定时器
      endChatTimer: null
    }
  },
  watch: {
    showEvaluate (val) {
      if (val) {
        let inputEle = this.$refs.input
        inputEle && inputEle.blur()
      }
    },
    showEmojiPicker (showEmojiPicker) {
      if (showEmojiPicker) {
        this.scrollBottom()
        this.showFile = false
      }
    },
    showFile (showFile) {
      if (showFile) {
        this.scrollBottom()
        this.showEmojiPicker = false
      }
    },
    input (input) {
      if (input.length > 0) {
        this.showSendBtn = true
      } else {
        this.showSendBtn = false
      }
    }
  },
  methods: {
    // 初始化聊天记录
    initHistoryRecord () {

    },
    // 检测浏览器前缀以兼容不同浏览器
    getHiddenProperty () {
      if (typeof document.hidden !== 'undefined') {
        return 'hidden'
      }
      if (typeof document.msHidden !== 'undefined') {
        return 'msHidden'
      }
      if (typeof document.webkitHidden !== 'undefined') {
        return 'webkitHidden'
      }
      return null
    },
    unbindGetPageIsHiddenEvent () {
      let hiddenProperty = this.getHiddenProperty()
      // 检查浏览器是否支持页面可见性API
      if (hiddenProperty) {
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange')
        document.removeEventListener(visibilityChangeEvent, this.getPageIsHidden)
      }
    },
    bindGetPageIsHiddenEvent () {
      let hiddenProperty = this.getHiddenProperty()
      // 检查浏览器是否支持页面可见性API
      if (hiddenProperty) {
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange')
        document.addEventListener(visibilityChangeEvent, this.getPageIsHidden)
      }
    },
    // 判断当前页面是否被切到后台
    async getPageIsHidden () {
      let hiddenProperty = this.getHiddenProperty()
      this.isPageHidden = document[hiddenProperty]
      // 用户切回前台
      if (!this.isPageHidden) {
        // 已显示过评价弹框 自动关闭并返回机器人页
        this.showEvaluate && this.logout()
        // 已超时 提示并返回机器人页
        if (this.isOverTime) {
          Toast({
            message: this.$lang.timeout_tips,
            duration: 5000
          })
          this.logout()
        }
        // 判断当前客服是否已结束用户的会话
        let params = {
          userId: this.imUserInfo.userID,
          customerUserid: this.serviceId
        }
        queryIsUserEndSession(params).then(res => {
          if (res.resultCode === 0) {
            if (res.resultData.isEndSession === 0) {
              // 会话已被结束
              Toast(this.$lang.consultation_has_ended)
              this.logout()
            }
          }
        })
      }
    },
    // 将路由中的平台用户id为修改为随机id
    updateUrlRandomUserId () {
      let localKey = `${this.platformType}_randomUserId`
      let randomUserId = localStorage.getItem(localKey) || Math.round(Math.random() * Date.now())
      localStorage.setItem(localKey, randomUserId)
      let queryObj = this.$route.query
      queryObj.randomUserId = randomUserId
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 切换分类 不隐藏emoji
    handleChangeCategory () {
      setTimeout(() => {
        this.showEmojiPicker = true
      }, 5)
    },
    selectEmoji (value) {
      this.input = this.input + value
      let editInput = document.querySelector('#input')
      editInput && editInput.focus()
    },
    // 监听app交互事件
    initAppInteractive () {
      // 允许文件授权 并接受文件数据
      window['allowAuthority'] = (type, data) => {
        let fileType = ''
        let fileName = ''
        let file = ''
        if (this.isIos) {
          // 接收到的文件类型
          fileType = data.split(',')[0].match(/:(.*?);/)[1].split('/')[1]
          // 随机生成文件名
          fileName = Math.round(Math.random() * 1000) + '.' + fileType
          file = this.dataURLtoFile(data, fileName)
        }
        switch (type) {
          case '1':
            // 发送图片
            if (this.isIos) {
              this.tencentSendImage(file)
            } else {
              this.$refs.imgUpload.click()
            }
            break
          case '2':
            // 发送视频
            if (this.isIos) {
              this.tencentSendVideo(file)
            } else {
              this.$refs.videoUpload.click()
            }
            break
          default:
            // 发送文件
            break
        }
      }
    },
    // 长按消息
    handleItemLongPress ({e, index}) {
      this.currentMessage = this.chatData[index]
      // 文本信息才显示复制
      this.currentMessage.showCopy = Boolean(this.currentMessage.messageType === 'TIMTextElem')
      // 自己发的信息 & 无进度条的消息才可撤回
      this.currentMessage.showRecall = Boolean(this.currentMessage.isMe && !this.currentMessage.isSending)
      this.showMenu = this.currentMessage.showCopy || this.currentMessage.showRecall
      if (this.showMenu) {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let clientX = e.changedTouches[0].clientX
        let clientY = e.changedTouches[0].clientY
        this.$nextTick(() => {
          document.querySelector('#menu').style.left = clientX + 'px'
          document.querySelector('#menu').style.top = clientY + scrollTop + 'px'
        })
        setTimeout(() => {
          this.showMenu = false
        }, 3500)
      }
    },
    // 腾讯云发送视频
    tencentSendVideo (file) {
      let currentMessage = {
        isSending: true,
        showProgress: true,
        isMe: true,
        messageType: 'TIMVideoFileElem',
        videoUrl: '',
        msgTime: Date.now()
      }
      this.chatData.push(currentMessage)
      this.scrollBottom()
      this.startAutoEndChatTimer()
      let message = this.tim.createVideoMessage({
        to: this.serviceId,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          file: file
        },
        onProgress: (e) => {
          currentMessage.uploadProgress = Math.round(e * 100)
        }
      })
      let promise = this.tim.sendMessage(message)
      promise.then((imResponse) => {
        let resInfo = imResponse.data.message
        currentMessage.videoUrl = resInfo.payload.videoUrl
        currentMessage.msgSeq = resInfo.sequence
        currentMessage.msgTime = resInfo.time * 1000
        currentMessage.msgRandom = resInfo.random
      }).catch((imError) => {
        currentMessage.hidden = true
        this.$forceUpdate()
        Toast(this.$lang.VideoSendingFailed + '\n' + imError)
      }).finally(() => {
        this.$refs.videoUpload.value = null
        currentMessage.isSending = false
        currentMessage.showProgress = false
      })
    },
    // 校验图片是否合格
    async checkImageByFile (file) {
      const base64Url = await this.getBase64ByFile(file)
      return new Promise((resolve, reject) => {
        imgOrTextCheck({
          // 检查类型：1文本，2图片
          platformType: 5,
          userId: this.imUserInfo.userID,
          checkType: 2,
          businessType: 5,
          violationContent: base64Url
        }).then(res => {
          if (res.resultCode === 0) {
            resolve(res.resultData.result)
          } else {
            reject(new Error(res.resultMessage))
          }
        }).catch(() => {
          reject(new Error(this.$lang.imageSendingFailed))
        })
      })
    },
    // 腾讯云发送图片
    async tencentSendImage (file) {
      let base64Url = await this.getBase64ByFile(file)
      let currentMessage = {
        isSending: true,
        showProgress: true,
        uploadProgress: 0,
        isMe: true,
        messageType: 'TIMImageElem',
        imgUrl: base64Url || '',
        msgTime: Date.now()
      }
      this.chatData.push(currentMessage)
      this.scrollBottom()
      this.checkImageByFile(file).then(res => {
        if (res) {
          // 图片校验通过
          this.startAutoEndChatTimer()
          let message = this.tim.createImageMessage({
            to: this.serviceId,
            conversationType: TIM.TYPES.CONV_C2C,
            payload: {
              file: file
            },
            onProgress: (e) => {
              currentMessage.uploadProgress = Math.round(e * 100)
            }
          })
          let promise = this.tim.sendMessage(message)
          promise.then((imResponse) => {
            let resInfo = imResponse.data.message
            currentMessage.msgSeq = resInfo.sequence
            currentMessage.msgTime = resInfo.time * 1000
            currentMessage.msgRandom = resInfo.random
          }).catch((imError) => {
            currentMessage.hidden = true
            this.$forceUpdate()
            Toast(this.$lang.imageSendingFailed + '\n' + imError)
          }).finally(() => {
            currentMessage.isSending = false
            currentMessage.showProgress = false
          })
        } else {
          // 图片校验不通过
          Toast(this.$lang.imageNotCompliantTips)
          currentMessage.hidden = true
          this.$forceUpdate()
        }
      }).catch(errorMsg => {
        currentMessage.hidden = true
        this.$forceUpdate()
        Toast((errorMsg + '').replace('Error:', ''))
      }).finally(() => {
        this.$refs.imgUpload.value = null
      })
    },
    // base64转文件对象
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    // 判断当前时间是否在某个时间段内
    isCurrentTimeInRange (startTime, endTime) {
      if (!startTime || !endTime) {
        return false
      }
      // 解析时间字符串为分钟数（例如 "08:00" -> 480）
      const parseTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number)
        return hours * 60 + minutes
      }
      // 获取当前时间的分钟数
      const getCurrentTimeInMinutes = () => {
        const now = new Date()
        return now.getHours() * 60 + now.getMinutes()
      }
      const start = parseTime(startTime)
      const end = parseTime(endTime)
      const current = getCurrentTimeInMinutes()
      if (start === end) {
        return true
      } else if (start < end) {
        // 处理不跨天的情况（开始时间早于结束时间）
        return current >= start && current <= end
      } else {
        // 处理跨天的情况（开始时间晚于结束时间）
        return current >= start || current <= end
      }
    },
    // 是否需要留言
    async isNeedMessage () {
      let params = {
        platformId: this.$theme.pid
      }
      const {data} = await queryImNoteSet(params)
      let config = data.resultData
      if (config.switchs === 2) {
        // 留言开关关闭 无需留言
        return false
      }
      if (config.pattern === 2 && config.isOnLine === 2) {
        // 留言全时段开放且无客服在线 需要留言
        return true
      }
      if (config.pattern === 2 && config.isOnLine === 1) {
        // 留言全时段开放且有客服在线 无需留言
        return false
      }
      // 留言按时段开放 判断当前时间是否在留言时间段内
      if (config.pattern === 1) {
        return this.isCurrentTimeInRange(config.startTime, config.endTime)
      }
    },
    async textPaste (event) {
      var clp = event.clipboardData || window.clipboardData
      let imgFile = ''
      if (clp.items[0]) {
        imgFile = clp.items[0].getAsFile()
      }
      if (imgFile) {
        // 粘贴的是图片
        let formdata = new FormData()
        // 记录当前图片对象
        this.copyImgFile = imgFile
        formdata.append('imgFile', imgFile)
        imgUpload(formdata).then(res => {
          Dialog.confirm({
            title: this.$lang.sendPictures,
            confirmButtonText: this.$lang.send,
            cancelButtonText: this.$lang.cancel,
            message: `<img src='${res.data.resultData.fileUrl}'>`
          })
            .then(() => {
              // on confirm
              this.tencentSendImage(this.copyImgFile)
            })
            .catch(() => {
              // on cancel
            })
        })
      }
    },
    submitMessage () {
      if (this.isMessageSubmitLoading) {
        return
      }
      if (!this.messageForm.phone) {
        Toast(this.$lang.phonePlaceholder)
        return false
      }
      if (!/^1[3456789][0-9]{9}(,1[3456789][0-9]{9})*$/.test(this.messageForm.phone)) {
        Toast(this.$lang.errorPhoneTips)
        return false
      }
      if (!this.messageForm.noteInfo) {
        Toast(this.$lang.descriptionRequiredTips)
        return false
      }
      this.isMessageSubmitLoading = true
      submitImNoteRecord(this.messageForm).then(res => {
        if (res.data.resultCode === 0) {
          Toast(this.$lang.submittedSuccessfully)
          this.logout()
        } else {
          Toast(res.data.resultMessage)
        }
      }).finally(() => {
        this.isMessageSubmitLoading = false
      })
    },
    // 复制
    toCopy () {
      let temp = document.querySelector('#copyContainer')
      temp.value = this.currentMessage.messageText
      temp.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      Toast(this.$lang.copySuccessfully)
      let inputEle = this.$refs.input
      inputEle && inputEle.focus()
    },
    // 撤回
    handleMessageRecall () {
      let item = this.currentMessage
      // 视频消息延迟为2s 其余1s
      let timeout = item.messageType === 'TIMVideoFileElem' ? 2000 : 1000
      item.isSending = true
      let msgTime = isNaN(item.msgTime) ? new Date(item.msgTime).getTime() / 1000 : item.msgTime / 1000
      let data = {
        msgKey: item.msgSeq + '_' + item.msgRandom + '_' + msgTime
      }
      setTimeout(() => {
        messageRecall(data).then(res => {
          if (res.data.resultCode === 0) {
            this.getHistory()
          } else {
            Toast(res.data.resultMessage)
          }
        }).catch(() => {
          Toast('出错了')
        }).finally(() => {
          item.isSending = false
          this.$forceUpdate()
        })
      }, timeout)
    },
    // 显示不在客服值班时间内提示弹框
    showNoWorkTimeTips () {
      Dialog.confirm({
        title: this.$lang.tips,
        confirmButtonText: this.$lang.leaveAMessage,
        cancelButtonText: this.$lang.cancel,
        message: this.$lang.noWorkTimeTips
      }).then(() => {
        this.showMessage = true
      }).catch(() => {
        this.logout()
      })
    },
    // 初始化websocket
    initMyWebsocket () {
      this.myWebsocket = createWebSocket(this.socketUrl + this.imUserInfo.userID, {
        maxReconnectCount: 30,
        reconnectInterval: 3000,
        heartbeatInterval: 30 * 1000,
        heartbeatMsg: 'heartCheck'
      })
      // 监听WebSocket事件
      this.myWebsocket.on('open', () => {
        // console.log('ws已连接')
      })
      this.myWebsocket.on('message', (data) => {
        // console.log('接收到ws消息', data)
        switch (data.flagType) {
          case 1:
            // 转接客服id
            this.serviceId = JSON.parse(data.msgBody).customerUserId
            this.getHistory()
            this.customerNickName = JSON.parse(data.msgBody).customerUserName
            break
          case 2:
            // 排队成功通知
            // this.isLine = false
            this.serviceId = data.objectBody.customerUserId
            this.customerNickName = data.objectBody.nickName
            this.waitUserCount = -1
            this.getHistory()
            break
          case 3:
            // 排队数量变化通知
            if (data.objectBody.waitUserCount >= 0) {
              this.waitUserCount = data.objectBody.waitUserCount
            }
            break
          case 4:
            // 回复心跳
            break
          case 5:
            // 用户断开通知
            break
          case 6:
            // 结束会话
            this.myWebsocket.close()
            this.showEvaluate = true
            break
          case 7:
            // 维持心跳
            break
          case 8:
            // 通知客服排队人数
            break
          case 10:
            // 排队数量变化通知
            if (data.objectBody.waitUserCount >= 0) {
              this.waitUserCount = data.objectBody.waitUserCount
            }
            break
          default:
            break
        }
      })
      this.myWebsocket.on('close', (event) => {
        // console.log(`ws已关闭 (${event.code})`)
      })
      this.myWebsocket.on('error', () => {
        // console.error('ws错误:', error)
      })
    },
    // 登出
    logout () {
      this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
      this.myWebsocket && this.myWebsocket.close()
      this.tim.logout()
      this.$router.push({
        path: '/',
        query: {
          ...this.$route.query
        }
      })
    },
    // 暂不提交工单
    noSubmit () {
      this.showEvaluate = false
      this.logout()
    },
    // 切换评价标签
    changeTabs (tab) {
      if (this.evaluationForm.evaluationLabel.includes(tab)) {
        let index = this.evaluationForm.evaluationLabel.indexOf(tab)
        this.evaluationForm.evaluationLabel.splice(index, 1)
      } else {
        this.evaluationForm.evaluationLabel.push(tab)
      }
    },
    // 修改路由中的平台用户类型为游客
    updateTouristType () {
      let queryObj = this.$route.query
      queryObj.platformUserType = 7
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 将路由中的课程信息参数删掉
    updateCourseUrl () {
      let queryObj = this.$route.query
      if (queryObj.courseScheduleId) {
        delete queryObj.courseScheduleId
        delete queryObj.sellCourseScheduleId
        delete queryObj.classType
        delete queryObj.courseScheduleName
        delete queryObj.courseScheduleImg
        delete queryObj.teacherName
        delete queryObj.courseSellPrice
      }
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 发送自定义消息
    async sendCustomMessage (e) {
      if (!this.isSendCustom && this.$route.query.courseScheduleId && this.$route.query.sellCourseScheduleId) {
        this.isSendCustom = true
        let queryParams = {
          ...this.$route.query
        }
        this.startAutoEndChatTimer()
        let courseInfo = {
          courseScheduleId: queryParams.courseScheduleId,
          sellCourseScheduleId: queryParams.sellCourseScheduleId,
          classType: queryParams.classType,
          courseScheduleName: queryParams.courseScheduleName,
          courseScheduleImg: queryParams.courseScheduleImg,
          teacherName: queryParams.teacherName,
          courseSellPrice: queryParams.courseSellPrice
        }
        let currentMessage = {
          isMe: true,
          messageType: 'TIMCustomElem',
          isSending: true,
          courseInfo: {
            ...courseInfo
          },
          msgTime: Date.now()
        }
        this.chatData.push(currentMessage)
        let message = this.tim.createCustomMessage({
          to: this.serviceId,
          conversationType: TIM.TYPES.CONV_C2C,
          payload: {
            data: JSON.stringify(courseInfo)
          }
        })
        this.tim.sendMessage(message).then(imResponse => {
          // console.log('自定义消息发送成功', promise)
          let resInfo = imResponse.data.message
          currentMessage.msgSeq = resInfo.sequence
          currentMessage.msgTime = resInfo.time * 1000
          currentMessage.msgRandom = resInfo.random
          this.updateCourseUrl()
        }).catch(() => {
          currentMessage.hidden = true
          this.$forceUpdate()
          Toast('课程发送失败')
        }).finally(() => {
          currentMessage.isSending = false
        })
      }
    },
    // 提交评价
    submitEvaluate () {
      if (this.isEvaluateLoading) {
        return
      }
      if (this.evaluationForm.evaluationLabel.length === 0) {
        Toast(this.$lang.labelSelectTips)
        return
      }
      this.evaluationForm.byEvaluationId = this.serviceId
      this.evaluationForm.evaluationId = this.imUserInfo.userID
      this.isEvaluateLoading = true
      submitImEvaluationRecord(this.evaluationForm).then(res => {
        if (res.data.resultCode === 0) {
          Toast(this.$lang.submittedSuccessfully)
          this.showEvaluate = false
          this.logout()
        } else {
          Toast(res.data.resultMessage)
        }
      }).finally(() => {
        this.isEvaluateLoading = false
      })
    },
    // 切换满意/不满意
    changeResult (result) {
      this.evaluationForm.evaluationLabel = []
      this.$set(this.evaluationForm, 'satisfaction', result)
    },
    // 简化历史记录的数据结构
    handleHistoryData (data) {
      data.forEach(item => {
        // 是否是我发送的消息
        item.isMe = Boolean(item.fromAccount === this.userInfo.userID)
        // 消息类型
        item.messageType = item.msgBody[0].msgType
        let msgContent = item.msgBody[0].msgContent[0]
        // 文本消息
        item.messageText = msgContent.text
        // 自定义消息
        item.courseInfo = msgContent.date ? JSON.parse(msgContent.date) : {}
        // 图片消息
        item.imgUrl = msgContent.imageInfoArray && msgContent.imageInfoArray[0].url
        item.imgUrl = item.imgUrl && item.imgUrl.split('?Expires=')[0]
        // 文件消息
        item.fileName = msgContent.fileName
        item.fileUrl = msgContent.url
        item.fileUrl = item.fileUrl && item.fileUrl.split('?Expires=')[0]
        // 视频消息
        item.videoUrl = msgContent.videoUrl
        item.videoUrl = item.videoUrl && item.videoUrl.split('?Expires=')[0]
      })
      return data
    },
    // 获取聊天记录
    async getHistory () {
      if (!this.serviceId) {
        return
      }
      let params = {
        userId: this.imUserInfo.userID,
        currentPage: 1,
        pageSize: 30,
        isUserFlag: 1,
        startTime: formatDateByTimestamp(Date.now() - (1000 * 60 * 60 * 24 * 30 * 6)),
        endTime: formatDateByTimestamp(Date.now())
      }
      const {data} = await queryChatHistoryRecord(params)
      if (data.resultCode === 0) {
        this.chatData = this.handleHistoryData(data.resultData)
        this.scrollBottom()
      } else {
        Toast(data.resultMessage)
      }
    },
    startAutoEndChatTimer () {
      this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
      // 平台自动结束会话分钟数
      let autoCloseSessionMin = Number(this.platformInfo.autoCloseSessionMin) || 5
      this.autoEndChatTimer = setTimeout(() => {
        if (this.isPageHidden) {
          this.isOverTime = true
        } else {
          // 用户停在当前页
          this.showEvaluate = true
          this.myWebsocket && this.myWebsocket.close()
          this.tim.logout()
        }
      }, 1000 * 60 * autoCloseSessionMin)
    },
    // 登录
    async handleUserLogin () {
      if (!this.queryForm.platformUserId) {
        this.updateTouristType()
      }
      // 需要留言
      if (await this.isNeedMessage()) {
        this.showNoWorkTimeTips()
        return
      }
      // 无需留言
      let params = {
        ...this.queryForm,
        platformPhone: (['undefined', 'null', ''].includes(this.$route.query.platformPhone) ? '' : this.$route.query.platformPhone),
        platformUserId: this.platformUserId || this.$route.query.randomUserId,
        platformId: this.$theme.pid
      }
      addImUser(params).then(res => {
        if (res.data.resultCode === 0) {
          let loginData = res.data.resultData
          this.serviceId = loginData.customerUserId
          this.customerNickName = loginData.customerNickName
          this.imUserInfo = {
            userID: loginData.userId,
            userSig: loginData.userSig
          }
          this.$store.commit('setUserInfo', this.imUserInfo)
          // 先获取历史记录
          // await this.getHistory()
          // 开始登录im
          let promise = this.tim.login(this.imUserInfo)
          promise.then((imResponse) => {
            // 登录成功
            this.$store.commit('setPlatformType', this.queryForm.platformType)
            this.initMyWebsocket()
            this.imWatch()
            // 获取历史记录 获取完毕再监听消息接收
            setTimeout(async () => {
              await this.getHistory()
              this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.imReceived)
              this.sendCustomMessage()
            }, 500)
            // 开启自动关闭会话定时器
            this.startAutoEndChatTimer()
            this.bindGetPageIsHiddenEvent()
          }).catch((error) => {
            // 登录错误
            console.log('err', error)
            this.$toast(error)
          })
          if (res.data.resultData.waitUserCount > -1) {
            // this.isLine = true
            this.waitUserCount = res.data.resultData.waitUserCount
            this.title = this.$lang.noFreeService
          }
        } else {
          this.noServiceTxt = res.data.resultMessage
          this.noService = true
          Dialog.alert({
            title: this.$lang.tips,
            confirmButtonText: this.$lang.goBack,
            message: res.data.resultMessage + '\n' + this.$lang.useRobotTips
          }).then(() => {
            this.logout()
          }).catch(() => {
            this.logout()
          })
        }
      })
    },
    // im事件监听
    imWatch () {
      // 多端登录踢出
      this.tim.on(TIM.EVENT.KICKED_OUT, this.imKickedOut)
      // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
      this.tim.on(TIM.EVENT.SDK_READY, this.imReady)
      this.tim.on(TIM.EVENT.MESSAGE_REVOKED, this.imRevoked)
      // 接受到某条消息
      // this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.imReceived)
      // 会话列表更新
      this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.imListUpdate)
    },
    imKickedOut (event) {
      this.myWebsocket && this.myWebsocket.close()
      this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
      let kickedType = event.data.type
      let message = ''
      if (kickedType === 'multipleAccount') {
        message = this.$lang.multipleAccountTips
      } else {
        message = this.$lang.loginSessionExpired
      }
      Dialog.alert({
        title: this.$lang.tips,
        message: message
      }).then(() => {
        this.logout()
      })
    },
    imReady () {
    },
    imRevoked () {
      setTimeout(() => {
        this.getHistory()
      }, 500)
    },
    imListUpdate () {
    },
    imReceived (event) {
      // 接收到消息
      if (!this.serviceId) {
        return
      }
      let messageInfo = event.data[0]
      if (noShowMessage.includes(messageInfo.payload.text)) {
        // 接收到不需要显示的消息
        return
      }
      if (logoutMessage.includes(messageInfo.payload.text)) {
        // 接收到需要自动退登的消息
        this.myWebsocket && this.myWebsocket.close()
        this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
        this.showEvaluate = true
        this.tim.logout()
        return
      }
      let currentMessage = {
        isMe: false,
        messageType: messageInfo.type,
        messageText: messageInfo.payload.text,
        courseInfo: messageInfo.date ? JSON.parse(messageInfo.date) : {},
        imgUrl: messageInfo.payload.imageInfoArray && messageInfo.payload.imageInfoArray[0].url,
        fileName: messageInfo.payload.fileName,
        fileUrl: messageInfo.payload.url,
        videoUrl: messageInfo.payload.videoUrl,
        msgTime: messageInfo.time * 1000
      }
      this.chatData.push(currentMessage)
    },
    // 返回
    goBack () {
      this.myWebsocket && this.myWebsocket.close()
      this.tim.logout()
      this.autoEndChatTimer && clearTimeout(this.autoEndChatTimer)
      if (this.serviceId) {
        this.showEvaluate = true
      } else {
        this.$router.push({
          path: '/',
          query: {
            ...this.$route.query
          }
        })
      }
    },
    // 滚动到底部
    scrollBottom () {
      setTimeout(() => {
        $('#chatContent').animate({
          scrollTop: 100000
        }, 200)
      }, 200)
    },
    // 关闭表情选择器与文件选择器
    hiddenMenu () {
      this.showEmojiPicker = false
      this.showFile = false
      this.showMenu = false
    },
    // 发送文件
    handleFileChange () {
      if (!/msword/.test(this.$refs.fileUpload.files[0].type) && !/document/.test(this.$refs.fileUpload.files[0].type) && !/pdf/.test(this.$refs.fileUpload.files[0].type) && !/powerpoint/.test(this.$refs.fileUpload.files[0].type)) {
        Toast(this.$lang.fileTypeTips)
        return
      }
      if (this.$refs.fileUpload.files[0].size > 1024 * 1024 * 50) {
        Toast(this.$lang.fileSizeTips)
        return
      }
      let currentMessage = {
        isSending: true,
        showProgress: true,
        isMe: true,
        messageType: 'TIMFileElem',
        fileName: this.$refs.fileUpload.files[0].name,
        fileUrl: '',
        uploadProgress: 0,
        msgTime: Date.now()
      }
      this.chatData.push(currentMessage)
      this.scrollBottom()
      this.startAutoEndChatTimer()
      let message = this.tim.createFileMessage({
        to: this.serviceId,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          file: this.$refs.fileUpload.files[0]
        },
        onProgress: (e) => {
          currentMessage.uploadProgress = Math.round(e * 100)
        }
      })
      let promise = this.tim.sendMessage(message)
      promise.then((imResponse) => {
        let resInfo = imResponse.data.message
        currentMessage.fileUrl = resInfo.payload.fileUrl
        currentMessage.msgSeq = resInfo.sequence
        currentMessage.msgTime = resInfo.time * 1000
        currentMessage.msgRandom = resInfo.random
      }).catch((imError) => {
        currentMessage.hidden = true
        this.$forceUpdate()
        Toast(this.$lang.fileSendingFailed + '\n' + imError)
      }).finally(() => {
        this.$refs.fileUpload.value = null
        currentMessage.isSending = false
        currentMessage.showProgress = false
      })
    },
    // 发送文本消息
    sendText () {
      if (!this.input.trim()) {
        Toast(this.$lang.cannotSendEmpty)
        return false
      }
      let currentMessage = {
        isSending: true,
        isMe: true,
        messageType: 'TIMTextElem',
        messageText: this.input,
        msgTime: Date.now()
      }
      this.chatData.push(currentMessage)
      this.scrollBottom()
      this.startAutoEndChatTimer()
      let message = this.tim.createTextMessage({
        to: this.serviceId,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          text: this.input
        }
      })
      let promise = this.tim.sendMessage(message)
      this.input = ''
      promise.then((imResponse) => {
        let resInfo = imResponse.data.message
        currentMessage.msgSeq = resInfo.sequence
        currentMessage.msgTime = resInfo.time * 1000
        currentMessage.msgRandom = resInfo.random
        this.scrollBottom()
      }).catch((imError) => {
        currentMessage.hidden = true
        this.$forceUpdate()
        Toast(this.$lang.failInSend)
      }).finally(() => {
        currentMessage.isSending = false
      })
    },
    // 发送视频
    handleVideoChange () {
      let file = this.$refs.videoUpload.files[0]
      let isVideo = /video\/\w+/.test(file.type)
      if (!isVideo) {
        Toast(this.$lang.pleaseSelectVideo)
        return
      }
      if (file.size > 1024 * 1024 * 50) {
        Toast(this.$lang.videoSizeTips)
        return
      }
      // ios发送mov视频处理
      if (file.name.indexOf('.MOV') >= 0 || file.name.indexOf('.mov') >= 0) {
        // 当做文本消息处理
        this.$refs.videoUpload.value = null
        let currentMessage = {
          isMe: true,
          messageType: 'TIMTextElem',
          messageText: this.$lang.Sending,
          isSending: true,
          msgTime: Date.now()
        }
        this.chatData.push(currentMessage)
        this.scrollBottom()
        let formdata = new FormData()
        formdata.append('videoFile', file)
        movConversionMp4(formdata).then(res => {
          if (res.data.resultCode === 0) {
            let movUrl = res.data.resultData.videoUrl.split('?Expires=')[0]
            let text = this.$lang.viewVideoPleaseClick + `\n<a href='${movUrl}' ontouchstart='window.location.href="${movUrl}"' target="_blank">${movUrl}</a>`
            this.startAutoEndChatTimer()
            currentMessage.messageText = text
            let message = this.tim.createTextMessage({
              to: this.serviceId,
              conversationType: TIM.TYPES.CONV_C2C,
              payload: {
                text: text
              }
            })
            let promise = this.tim.sendMessage(message)
            promise.then((imResponse) => {
              let resInfo = imResponse.data.message
              currentMessage.msgSeq = resInfo.sequence
              currentMessage.msgTime = resInfo.time * 1000
              currentMessage.msgRandom = resInfo.random
            }).catch((imError) => {
              currentMessage.hidden = true
              this.$forceUpdate()
              Toast(this.$lang.VideoSendingFailed + '\n' + imError)
            }).finally(() => {
              currentMessage.isSending = false
            })
          } else {
            Toast(res.data.resultMessage)
            currentMessage.hidden = true
            this.$forceUpdate()
          }
        }).catch(() => {
          currentMessage.hidden = true
          this.$forceUpdate()
          Toast(this.$lang.sendingfailedTryAgainTips)
        })
        return
      }
      // ios发送mov视频处理结束
      this.tencentSendVideo(file)
    },
    // file文件转为base64
    getBase64ByFile (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        // 开始读文件
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        // 失败返回失败的信息
        reader.onerror = error => reject(error)
      })
    },
    // 发送图片
    handleImgChange () {
      let file = this.$refs.imgUpload.files[0]
      let isImg = /image\/\w+/.test(file.type)
      if (!isImg) {
        Toast(this.$lang.selectPictureToSend)
        return
      }
      if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp') {
        if (file.size > 1024 * 1024 * 10) {
          Toast(this.$lang.pictureSizeTips)
          return
        }
        this.tencentSendImage(this.$refs.imgUpload.files[0])
      }
    },
    // 打开图片选择
    openImgUpload () {
      if (this.authority === 1) {
        // 需要权限判断
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          try {
            return window.webkit.messageHandlers.phoneAlbum.postMessage(1)
          } catch (error) {
            this.$refs.imgUpload.click()
            console.log(error)
          }
        } else if (/(Android)/i.test(navigator.userAgent)) {
          try {
            return window.qd.phoneAlbum(1)
          } catch (error) {
            this.$refs.imgUpload.click()
            console.log(error)
          }
        }
      } else {
        // 不需要权限判断
        this.$refs.imgUpload.click()
      }
    },
    // 打开视频选择器
    openVideoUpload () {
      if (this.authority === 1) {
        // 需要权限判断
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          try {
            return window.webkit.messageHandlers.phoneAlbum.postMessage(2)
          } catch (error) {
            this.$refs.videoUpload.click()
            console.log(error)
          }
        } else if (/(Android)/i.test(navigator.userAgent)) {
          try {
            return window.qd.phoneAlbum(2)
          } catch (error) {
            this.$refs.videoUpload.click()
            console.log(error)
          }
        }
      } else {
        // 不需要权限判断
        this.$refs.videoUpload.click()
      }
    },
    // 打开文件选择器
    openFileUpload () {
      Dialog.confirm({
        title: this.$lang.tips,
        confirmButtonText: this.$lang.yes,
        cancelButtonText: this.$lang.cancel,
        message: this.$lang.allowAccessFiles
      }).then(() => {
        this.$refs.fileUpload.click()
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-box{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 0 20px 40px;
  .chat-item{
    position: relative;
    // overflow: hidden;
    *zoom: 1;
    &::after{
      content: '';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .loading{
      position: absolute;
      left: 290px;
      top: 50%;
      transform: translateY(-20%);
    }
    /deep/.el-progress{
      position: absolute;
      bottom: -20px;
      right: 40px;
    }
    .message-time{
      text-align: center;
      color: #999;
      font-size: 12px;
      margin-top: 18px;
    }
    .avatar{
      float: left;
      // width: 36px;
      // height: 36px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #efefef;
      margin-right: 11px;
      margin-top: 18px;
    }
    /deep/.message{
      float: left;
      max-width: 468px;
      background-color: #f6f6f6;
      border-radius: 1px 8px 8px 8px;
      padding: 9px 12px;
      margin-top: 18px;
      line-height: 22px;
      word-wrap: break-word;
      // white-space: normal;
      word-break: break-all;
      *{
        max-width: 100%!important;
        white-space: pre-wrap!important;
      }
      video{
        width: 230px;
      }
    }
    .system-message{
      display: flex;
      justify-content: center;
      margin-top: 18px;
      span{
        color: #fff;
        background-color: #DCDCDC;
        height: 24px;
        line-height: 24px;
        padding: 0 12px;
        border-radius: 12px;
        font-size: 12px;
      }
    }
    .img-message{
      float: left;
      width: 230px;
      margin-top: 18px;
      border-radius: 1px 8px 8px 8px;
      border: 1px solid #EFEFEF;
      cursor: pointer;
    }
    .file-message{
      display: flex;
      align-items: center;
      float: left;
      max-width: 230px;
      height: 70px;
      background-color: #5cacde;
      border-radius: 1px 8px 8px 8px;
      margin-top: 18px;
      padding: 0 10px;
      cursor: pointer;
      .el-icon-folder{
        font-size: 40px;
        color: #fff;
        margin-right: 7px;
      }
      .file-name{
        color: #fff;
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .video-message{
      float: left;
      margin-top: 18px;
      width: 230px;
      border-radius: 1px 8px 8px 8px;
    }
    &.right{
      img{
        float: right;
        margin-right: 0;
        margin-left: 11px;
      }
      .message{
        float: right;
        background-color: #0087Ff;
        color: #fff;
        border-radius: 8px 1px 8px 8px;
        margin-top: 18px;
      }
      .img-message{
        float: right;
        border-radius: 8px 1px 8px 8px;
      }
      .file-message{
        float: right;
        border-radius: 8px 1px 8px 8px;
      }
      .video-message{
        float: right;
        border-radius: 8px 1px 8px 8px;
      }
    }
  }
}
/deep/.el-loading-spinner .circular{
  width: 20px;
}
/deep/.el-progress{
  width: 230px;
}
.service{
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #F9F9F9;
  padding-bottom: 56px;
  /deep/#InputSearch{
    display: none;
  }
  /* 留言弹框 */
  .leave-message-container{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
    .message{
      position: fixed;
      width: 90%;
      max-width: 554px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid #ccc;
      padding: 20px;
      border-radius: 5px;
      background-color: #fff;
      box-sizing: 4px 4px 5px #eee;
      .close{
        position: absolute;
        right: -13px;
        top: -13px;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        line-height: 26px;
        background-color: #C0C4CC;
        color: #fff;
        text-align: center;
      }
      .submit-btn{
        width: 80%;
        margin: 8px auto 0;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 8px;
        color: #fff;
        background-color: var(--main-color);
      }
      .tips{
        text-align: center;
        margin-bottom: 20px;
      }
      .notice{
        color: #666;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .item{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
      }
      .label{
        width: 100px;
      }
      .alignTop{
        align-items: flex-start;
      }
      .input-area{
        flex: 1;
        input{
          width: 100%;
          // width: 90px;
          padding-left: 5px;
          height: 30px;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
        }
        textarea{
          width: 100%;
          padding: 5px;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
          resize: none;
        }
        select{
          height: 30px;
          width: 100%;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
        }
      }
    }
  }
  .menu{
    position: absolute;
    // top: 50%;
    // transform: translateY(-30%);
    // right: 50px;
    width: 70px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #ddd;
    z-index: 9999;
    .menu-item{
      background-color: #fff;
      text-align: center;
      width: 70px;
      height: 34px;
      line-height: 34px;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }
  .system-message{
    max-width: fit-content;
    text-align: center;
    margin: 20px auto 0;
    font-size: 10px;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #dcdcdc;
    color: #fff;
  }
  .line-count{
    text-align: center;
    margin-top: 10px;
    color: red;
  }
  // 编辑区域
  .edit{
    z-index: 100;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0px -5px 10px 0px rgba(80,106,150,0.08);
    background-color: #F9F9F9;
    /deep/.el-textarea{
      padding: 8px 0;
    }
    /deep/textarea:focus{
      border-color: transparent;
    }
    .top{
      display: flex;
      align-items: center;
      min-height: 56px;
      padding: 0 16px;
      .emoji-img{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        margin-right: 16px;
        background-color: #EFEFEF;
        border-radius: 50%;
        img{
          width: 24px;
          height: 24px;
        }
      }
      /deep/.el-textarea__inner{
        border: none;
        &:focus{
          border: transparent;
        }
      }
      .add-img{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-left: 16px;
        background-color: #EFEFEF;
        img{
          width: 24px;
          height: 24px;
        }
      }
      .send-btn{
        flex-shrink: 0;
        width: 50px;
        line-height: 28px;
        height: 28px;
        color: #fff;
        text-align: center;
        background-color: var(--main-color);
        border-radius: 14px;
        font-size: 12px;
        margin-left: 16px;
      }
    }
    /deep/.emoji-picker{
      width: 100vw;
      // height: 200px;
    }
    .bottom{
      display: flex;
      padding: 20px;
      height: 200px;
      .menu-item{
        margin-right: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .menu-title{
          // display: flex;
          // flex-direction: column;
          // align-items: center;
        }
        .img-icon, .file-icon{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #fff;
          margin-bottom: 8px;
          img{
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
  .overlay{
    z-index: 999;
  }
  // 评价
  .wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    // width: 80%;
    width: 300px;
    transform: translate(-50%, -50%);
    padding: 15px 20px;
    background-color: #fff;
    border-radius: 6px;
    .evaluate-close{
      position: absolute;
      top: 10px;
      right: 5px;
      width: 24px;
      height: 24px;
    }
    .evaluate-title{
      text-align: center;
      font-weight: 500;
      font-size: 16px;
    }
    /deep/.tips{
      color: #666;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
      span{
        color: #409EFF;
      }
    }
    .evaluate-result{
      display: flex;
      justify-content: space-evenly;
      margin-top: 17px;
      .result-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #999;
        img{
          width: 32px;
          height: 32px;
          margin-bottom: 8px;
        }
      }
    }
    .tabs-title{
      display: flex;
      align-items: center;
      color: #999;
      margin-top: 20px;
      &::before, &::after{
        flex: 1;
        content: '';
        display: block;
        height: 1px;
        background-color: #eee;
      }
      .title-tip{
        font-size: 14px;
        margin: 0 18px;
      }
    }
    .tabs{
      .tabs-item{
        float: left;
        padding: 0 26px;
        height: 34px;
        line-height: 34px;
        border: 1px solid #E8E8E8;
        border-radius: 4px;
        margin-right: 10px;
        margin-top: 10px;
        &.isSelected{
          position: relative;
          border-color: #0087FF;
          color: #0087FF;
          &::after{
            content: '✔';
            position: absolute;
            top: 0;
            right: 3px;
          }
        }
      }
    }
    .evaluate-input{
      margin-top: 10px;
    }
    .evaluate-submit{
      width: 100%;
      margin-top: 10px;
      border: none;
      background-color: var(--main-color);
    }
    .no-submit{
      color: #999;
      text-align: center;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Service.vue